import styled from 'styled-components';
import {
  Image as SemanticImage,
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Text = styled(TextLayoutComponent)`
  word-break: break-word;
`;

export const Image = styled(SemanticImage)`
  max-width: 90px;
  max-height: 60px;
  cursor: pointer;
`;

export const ContainerImageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Modal = styled(SemanticModal)`
  height: 100vh;
  width: 100vw;
  &.ui.modal {
    height: 70%;
    width: 70%;
    max-width: 1345px;
    max-height: 700px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 3%;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 80%;
`;

export const ModalImage = styled(SemanticImage)`
  max-width: 100%;
  max-height: 100%;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.color.link};
  text-decoration: none;
  cursor: pointer;
  font-weight: 400;
`;
